module.exports = __webpack_public_path__ + "75cc90bb95a614a974b227d35b8bc148.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_8.jpg
// module id = 1688
// module chunks = 5